import { ApplicationSettings } from '../../shared/models/application-settings.model';

/* eslint-disable @typescript-eslint/no-namespace */
export namespace AppSettings {
    export class load {
        public static readonly type = '[AppSettings] LoadApplicationSettings';
    }

    export class update {
        public static readonly type = '[AppSettings] SetShowEnvironmentHint';
        constructor(public data: ApplicationSettings) {}
    }
}
